import { request } from '.';
import { setUiState } from './ui';

const SET_EVENTS = 'SET_EVENTS';
const SET_EVENT = 'SET_EVENT';
const SET_EVENT_GUEST_COUNTS = 'SET_EVENT_GUEST_COUNTS';
const SET_EVENT_TICKET_SALES = 'SET_EVENT_TICKET_SALES';
const SET_META = 'SET_META';
const SET_EVENTS_COUNTS = 'SET_EVENTS_COUNTS';

const defaultState = {
  ticketSales: null,
  events: null,
  event: null,
  guestCounts: null,
  meta: null
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_EVENTS:
      return { ...state, events: action.payload, event: null };

    case SET_EVENT:
      return { ...state, event: action.payload };

    case SET_EVENT_GUEST_COUNTS:
      return { ...state, guestCounts: action.payload };

    case SET_EVENT_TICKET_SALES:
      return { ...state, ticketSales: action.payload };

    case SET_META:
      return { ...state, meta: action.payload };

    case SET_EVENTS_COUNTS:
      return { ...state, eventsCount: action.payload };

    default:
      return state;
  }
}

export function setEvents(events) {
  return {
    type: SET_EVENTS,
    payload: events
  };
}

export function setEventsCount(count) {
  return {
    type: SET_EVENTS_COUNTS,
    payload: count
  };
}

export function setEvent(event) {
  return {
    type: SET_EVENT,
    payload: event
  };
}
export function setEventGuestCounts(counts) {
  return {
    type: SET_EVENT_GUEST_COUNTS,
    payload: counts
  };
}
export function setEventTicketSales(amounts) {
  return {
    type: SET_EVENT_TICKET_SALES,
    payload: amounts
  };
}
export function setMeta(meta) {
  return {
    type: SET_META,
    payload: meta
  };
}
export function getEvents(limit, offset, sort_by, sort_order, search, id) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const params = { internal: 'true' };
        if (sort_by) params.sort_by = sort_by;
        if (sort_order) params.sort_order = sort_order;
        if (search) params.search = search;
        if (limit !== undefined) params.limit = limit;
        if (offset !== undefined) params.offset = offset;
        if (id !== undefined) params.id = id;
        const url = '/internal/events';
        dispatch(setUiState('loading'));
        const response = await request.get(url, { params });
        await dispatch(setEvents(response.data));
        const meta = {
          count: Number(response.headers['juven-count']) || 0,
          from: Number(response.headers['juven-from']) || 0,
          to: Number(response.headers['juven-to']) || 0
        };
        await dispatch(setMeta(meta));
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        console.error(e);
      }
    });
  };
}
export function getEventsCount() {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const params = { internal: 'true' };
        const url = '/internal/events/counts';
        dispatch(setUiState('loading'));
        const response = await request.get(url, { params });
        await dispatch(setEventsCount(response.data));
        dispatch(setUiState('complete'));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        console.error(e);
      }
    });
  };
}
export function getEventsList() {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/events/list`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));

        dispatch(setEvents(response.data));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        console.error(e);
      }
    });
  };
}

export function getEvent(id) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/events/${id}`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));

        dispatch(setEvent(response.data));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        console.error(e);
      }
    });
  };
}
export function deleteEvent(id) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/events/${id}`;
        dispatch(setUiState('loading'));
        await request.delete(url);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function updateEvent(id, data) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/events/${id}`;
        dispatch(setUiState('loading'));
        await request.put(url, data);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}

export function getEventGuestCounts(eId) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const url = `/events/${eId}/guests/counts`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        const counts = response.data;
        dispatch(setEventGuestCounts(counts));

        return resolve(counts);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}

export function getEventTicketSales(eId) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const url = `/events/${eId}/guests/sales`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        const amounts = response.data;
        dispatch(setEventTicketSales(amounts));

        return resolve(amounts);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}



// WEBPACK FOOTER //
// ./src/redux/events.js